export const PROTECTED_ROUTE_PREFIXES = [
  "/v1",
  "/auth",
  "/guest",
  "/staff",
  "/admin",
  "/documents",
  "/invoices",
  "/payments",
] as const;

export const PROTECTED_STORAGE_PREFIXES = [
  "whitehaven:protected:",
  "whitehaven:session:",
] as const;

export const WHITEHAVEN_CACHE_PREFIX = "whitehaven-";
export const WHITEHAVEN_SHELL_CACHE_PREFIX = "whitehaven-shell-";
export const PROTECTED_CACHE_PREFIX = "whitehaven-protected-";
export const PROTECTED_DATABASE_NAMES = ["whitehaven-protected-v1"] as const;

export type CleanupStageStatus = "cleared" | "skipped" | "failed";

export interface CleanupStageResult {
  readonly id: string;
  readonly status: CleanupStageStatus;
  readonly code?: string;
}

export interface CleanupReport {
  readonly status: "cleared" | "partial";
  readonly generation: number;
  readonly stages: readonly CleanupStageResult[];
}

export function isProtectedRoute(pathname: string): boolean {
  return PROTECTED_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function isProtectedStorageKey(key: string): boolean {
  return PROTECTED_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix));
}

export function isWhitehavenCacheName(cacheName: string): boolean {
  return cacheName.startsWith(WHITEHAVEN_CACHE_PREFIX);
}

export function isShellCacheName(cacheName: string): boolean {
  return cacheName.startsWith(WHITEHAVEN_SHELL_CACHE_PREFIX);
}

export function isProtectedCacheName(cacheName: string): boolean {
  return cacheName.startsWith(PROTECTED_CACHE_PREFIX);
}

export function shouldDeleteCacheAtLogout(cacheName: string): boolean {
  return isWhitehavenCacheName(cacheName) && !isShellCacheName(cacheName);
}
